export default {
  reviewCompleteHeader: '檢查並完成',
  participants: '參與者',
  enterParticipantInfoText: '請輸入必要的資料以繼續結帳。',
  purchaser: '購買者',
  firstName: '名字',
  lastName: '姓氏',
  email: '電子郵件',
  optionalEmail: '電子郵件（選填）',
  'phone:': '電話',
  participantFieldPlaceholder: '新增或選擇現有參與者',
  reservationSummary: '預約摘要',
  editParticipantsDetails: '編輯參與者資料',
  participantDetails: '詳細資料',
  duplicatePurchaserText: '與購買者相同',
  phone: '電話',
  addParticipant: '額外{{tierLabel}}',
  participant: '參與者',
  removeParticipant: '移除',
  experienceCheckoutCompleted: '體驗結帳完成',
  experienceCartCheckout: '體驗購物車結帳',
  experienceLimitReached: '很抱歉，此體驗已達最大參與人數上限',
  payment: '付款',
  duration: '時長',
  discountCode: '折扣碼',
  removeCode: '移除折扣碼',
  invalidCodeValidation: '無效的優惠碼',
  networkErrorDiscountCode: '系統發生錯誤，請稍後再試',
  onlyOneCouponCodeAllowed: '只能使用一個優惠碼',
  creditCodeHasAlreadyBeenApplied: '優惠碼已應用',
  discount: '折扣',
  promo: '促銷',
  promoCode: '促銷代碼',
  apply: '套用',
  total: '總計',
  subTotal: '小計',
  includes: '包含',
  and: '及',
  addHostNotes: '新增給主辦方的備註',
  brandAggreementText: '我同意，或代表參與者同意品牌的條款與條件',
  termsAggreementValidation: '請勾選同意條款',
  firstNameValidation: '名字為必填',
  lastNameValidation: '姓氏為必填',
  emailValidation: {
    emailRequiredText: '電子郵件為必填',
    invalidEmail: '無效的電子郵件地址',
    not_specified: '不正確的電子郵件地址',
  },
  phoneValidation: {
    'Invalid Phone Number': '無效的電話號碼',
    not_specified: '無效',
    phoneRequiredText: '電話號碼為必填',
  },
  participantFirstNameValidation: '參與者名字為必填',
  participantLastNameValidation: '參與者姓氏為必填',
  complete: '完成',
  '404Message': '找不到頁面',
  waiting: '請稍候...',
  complimentary: '免費',
  confirmationHeader: '您的體驗已預訂完成！',
  confirmationText: '確認信已寄送至 {{email}}，內含更多詳情',
  viewAll: '查看所有體驗',
  paymentMethod: '付款方式',
  creditCard: '信用卡',
  roomCharge: '房帳支付',
  memberCharge: '會員支付',
  roomOrReservationNumber: '房號或確認編號',
  roomNumber: '房號',
  roomNumberLegacy: '房號 / 確認碼',
  memberNumber: '會員編號',
  kicc: '簡易付款',
  chargeValidation: '需輸入房號與姓氏',
  memberNumberValidation: '會員編號為必填',
  invalidRoomNumber: '無效的房號',
  invalidRoomNumberLegacy: '無效的房號或確認碼',
  invalidMemberNumber: '無效的會員編號',
  invalidPhoneNumber: '無效的電話號碼',
  requiredPhoneNumber: '電話號碼為必填',
  guestNameIsRequired: '客人姓名為必填',
  roomNumberIsRequired: '房號為必填',
  roomNumberIsRequiredLegacy: '房號或確認碼為必填',
  roomOrReservationNumberIsRequired: '房號或確認編號為必填',
  cardNumberIncomplete: '卡號不完整',
  lastNameValidationError: '姓氏為必填',
  isReqd: '為必填',
  reservationCode: '預約／確認編號',
  nonHotelGuest: '非飯店住客',
  onPropertyGuest: '住宿住客',
  preArrivalGuest: '尚未報到住客',
  cardNumber: '卡號',
  pmsValidationErrorMessage: '姓氏或房號或確認編號無效',
  pmsDateValidationErrorMessage: '體驗日期不在您的住宿期間內',
  fullName: '全名',
  checkout: '結帳',
  editParticipants: '編輯參與者',
  private: '私人',
  browseAllExperieces: '瀏覽所有體驗',
  payWithCreditCard: '以信用卡付款',
  payWithRoomCharge: '以房帳付款',
  payWithMemberCharge: '以會員帳戶付款',
  payWith: '付款方式',
  bookBulkErrorByCard: '預訂失敗，信用卡未被扣款',
  bookBulkErrorByRoomCharge: '姓氏與房號無效',
  bookBulkErrorByMemberCharge: '姓氏與會員編號無效',
  reviewCancellation: '檢查取消預約',
  selectAReservationToCancel: '選擇要取消的預約',
  confirmCancellation: '確認取消',
  cancellable: '可取消',
  cancelled: '已取消',
  deadlinePassed: '已超過截止時間',
  noCancellations: '無可取消項目',
  reviewReschedule: '您的預約',
  selectAReservationToReschedule: '選擇要重新安排的預約',
  confirmReservation: '確認預約',
  confirm: '確認',
  selectADateAndTime: '選擇日期與時間',
  noOtherSessionsAvailableForThisExperience: '此體驗無其他可用場次',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    '此預約無法重新安排。請發送電郵至 {{brandEmail}}',
  thisReservationCannotBeRescheduled: '此預約無法重新安排',
  noTimesAvailable: '無可用時段',
  noBookingsAvailable: '無可預訂項目',
  youPaid: '您已支付',
  refund: '退款',
  yourRefund: '您的退款',
  yourRefundWillBeProcessedToTheOriginalPayment: '退款將退回至原付款方式',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    '此預約無法取消。請發送電郵至 {{brandEmail}}',
  reservationCancelled: '預約已取消',
  thisReservationCannotBeCancelled: '此預約無法取消',
  thisReservationHasAlreadyBeenCancelled: '此預約已取消',
  theHotel: '飯店',
  cancelling: '取消中',
  somethingWentWrong: '發生錯誤',
  previouslyRefunded: '已退款',
  remainingBalance: '剩餘金額',
  notEnoughPoints: '點數不足',
  notEnoughPointsDescription: '您的「凱悅天地」點數不足以完成此次購買。',
  currentPointsBalance: '目前點數餘額：{{count, number}}',
  points: '點',
  pointsWithCount_one: '{{count, number}} 點',
  pointsWithCount_other: '{{count, number}} 點',
  payWithHyattPoints: '以凱悅點數付款',
  pleaseSignIn: '請登入',
  worldOfHyattPoints: '凱悅天地點數',
  bookBulkErrorByNotEnoughSeats: '此場次剩餘座位不足，請選擇其他場次。',
  phoneNumber: '電話號碼',
  requestToBookConfirmationText: '確認信已寄送至 {{email}}',
  reservationRescheduled: '預訂已重新安排',
  yourReservationWasRescheduledTo: '您的預訂已重新安排至',
  viewExperiences: '查看體驗',
  joinBook: '加入並預訂',
  signInBook: '登入並預訂',
  signAndJoin: '登入或加入以預訂',
  signAndJoinDescription:
    'World of Hyatt FIND體驗僅對World of Hyatt會員開放。登入或加入以預訂並賺取點數。不想加入？您仍然可以通過從購物車中刪除World of Hyatt體驗來預訂非獨家體驗。',
  promoOrFind: '促銷代碼或 FIND 積分代碼',
  hyattTermsAndConditions: '條款與條件',
  hyattTermsAndConditionsAgreement:
    '確認此預訂即表示我同意取消政策。我也已閱讀並了解依照以下內容使用我的個人資料：',
  hyattTermsAndConditionsLink: '凱悅隱私權政策',
  hyattWaiverText:
    '購買此體驗即表示本人及由本人購買體驗後參與的任何人（如有）同意、理解並確認以下內容',
  hyattWaiverLink: '一般免責聲明',
  priceDisclaimer: '包含前稅費',
  curatedRecommendations: '精選推薦',
  moreExperiencesYouMightLike: '更多您可能喜歡的體驗',
  similarExperiencesAvailableToBookDirectly: '可直接預訂的相似體驗',
  experiencesAvailableAroundYourBookingDate: '預訂日期附近的可用體驗',
  confirmationEmailSent: '我們已將確認信寄送至 {{email}}，內含更多詳情。',
  youreBooked: '您已預訂',
  purchaserInformation: '購買者資訊',
  requiredFieldIndicator: '* 表示必填欄位',
  resourceSelectionTitle: '選擇您的選項',
  resourceSelectionDescription: '請為預訂中的每一項選擇一個選項。',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: '選擇{{attributeName}}',
  resourceValueSoldOut: '{{label}}（已售完）',
  resourceValueUnavailableWith: '{{label}}（不適用於{{picks}}）',
  resourceOptionsUnavailable: '無法載入此時段的選項，請再試一次。',
  resourceOptionsRetry: '再試一次',
  changeResourceSelections: '變更您的選擇',
};
